module.exports = __webpack_public_path__ + "img/breedband.ac2ac582.png";